import React from 'react'
import PropTypes from 'prop-types'

import { mapToSelectArray } from 'Shared/helpers'
import PopupTypes from '../../../popup_types'
import {
  GlgPopup,
  GlgPopupForm,
  GlgFormInput,
  GlgSelect,
} from 'SharedComponents'

const ChangeSeasonPopupSimGolf = ({ show, data, seasonsOptions, onClose, onSave }) => {
  const handleClose = () => {
    onClose(PopupTypes.CHANGE_SEASON)
  }

  const handleSave = (formData) => {
    if (data) {
      onSave(data.leagueId, formData.to_season_id)
    }
  }

  const leagueName = data?.leagueName || ''
  const currentSeasonId = data?.seasonId || ''
  const seasonsSelectOptions = mapToSelectArray(seasonsOptions)

  return (
    <GlgPopup
      modalClass='create_clone_event_league general_sim_golf_popup'
      title={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.change_season') }
      show={ show }
      onClose={ handleClose }
      onSave={ handleSave }
      saveButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.save') }
      closeButtonText={ !window.I18n ? '' : window.I18n.t('customer_center_comp.components.sim_golf_buttons.cancel') }
      >
      <span className='form_content_popup_sim_golf'>
        { leagueName && (
          <h2>{ leagueName }</h2>
        )}
        <GlgPopupForm>
          <GlgFormInput
            label={ !window.I18n ? '' : window.I18n.t('customer_center_menu.components.popups.sim_golf.season_label') }
          >
            <GlgSelect
              name='to_season_id'
              className='container_select'
              items={ seasonsSelectOptions }
              defaultValue={ currentSeasonId }
            />
          </GlgFormInput>
        </GlgPopupForm>
      </span>
    </GlgPopup>
  )
}

ChangeSeasonPopupSimGolf.propTypes = {
  data: PropTypes.object,
  show: PropTypes.bool.isRequired,
  seasonsOptions: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

export default ChangeSeasonPopupSimGolf
